import React, { ReactElement } from 'react'
import { Frame } from '@/components/layout/Frame/Frame'
import { UiLayoutConstant } from '@/globals/uiLayoutConstant'

export default function Index(): ReactElement {
    return <Frame page={UiLayoutConstant.SPLASH_PAGE} />
}
